// REMIX HMR BEGIN
import * as __hmr__ from "remix:hmr";
if (import.meta) {
import.meta.hot = __hmr__.createHotContext(
//@ts-expect-error
"app/entry.client.tsx"
);
import.meta.hot.lastModified = "1749472294424.9253";
}
// REMIX HMR END

import { hydrateRoot } from 'react-dom/client';
import { RemixBrowser } from '@remix-run/react';
import { startTransition, StrictMode } from 'react';
import i18n from './i18n';
import i18next from 'i18next';
import { I18nextProvider, initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { getInitialNamespaces } from 'remix-i18next';
import HttpBackend from 'i18next-http-backend';

async function hydrate() {
  // Force Czech as default
  if (!localStorage.getItem('selectedLanguage')) {
    localStorage.setItem('selectedLanguage', 'cs');
  }
  
  await i18next
    .use(initReactI18next)
    .use(LanguageDetector)
    .use(HttpBackend)
    .init({
      ...i18n,
      lng: 'cs', // Force Czech as default
      ns: getInitialNamespaces(),
      backend: { loadPath: '/locales/{{lng}}.json' },
      detection: {
        order: ['localStorage'],  // Only use localStorage for detection
        lookupLocalStorage: 'selectedLanguage',
        caches: ['localStorage'],
      },
      fallbackLng: 'cs',
      load: 'languageOnly',
      preload: ['cs'],
      nonExplicitSupportedLngs: false,
      supportedLngs: ['cs', 'en'],
    });

  startTransition(() => {
    hydrateRoot(
      document,
      <I18nextProvider i18n={i18next}>
        <StrictMode>
          <RemixBrowser />
        </StrictMode>
      </I18nextProvider>,
    );
  });
}

if (window.requestIdleCallback) {
  window.requestIdleCallback(hydrate);
} else {
  // Safari doesn't support requestIdleCallback
  // https://caniuse.com/requestidlecallback
  window.setTimeout(hydrate, 1);
}
